import useMenuItem from '../../Menu/hooks/useMenuItem';
import { StyledListItem } from './GlobalToolbarItem';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarItem = ({
  render,
  id,
  portalHook,
  role = 'menuitem',
  style,
  dataOnboardingHook,
  additionalStyles
}) => {
  const menuItemData = useMenuItem({
    id
  });
  return /*#__PURE__*/_jsx(StyledListItem, {
    "data-portal-hook": portalHook,
    "data-onboarding-hook": dataOnboardingHook,
    role: role,
    style: style,
    additionalStyles: additionalStyles,
    children: render(menuItemData)
  }, id);
};
export default ToolbarItem;